import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson establece London Rubber Company y vende condones y accesorios importados.',
		},
		{
			year: 1929,
			description: 'London Rubber Company (LRC) registra la marca Durex®.',
		},
		{
			year: '1950s',
			description: 'Durex® lanza su primer condón humedecido.',
		},
		{
			year: 1953,
			description: 'Durex® es la primera marca en desarrollar y usar testeos electrónicos.',
		},
		{
			year: '1960s',
			description: 'Durex® lanza el primer condón con forma anatómica.',
		},
		{
			year: '1970s',
			description: 'Durex® es la primera marca de condones en el mundo en publicitar en varios países.',
		},
		{
			year: '1990s',
			description: 'Durex® es la primera marca de condones en adoptar un “sello de calidad” global como estándar.',
		},
		{
			year: 1995,
			description: 'Durex® lanza una gama de condones coloridos y saborizados.',
		},
		{
			year: 1996,
			description: 'Durex® es la primera marca de condones en tener su sitio web. Ahora contamos con 42 sitios web diferentes para los países en los cuales tenemos presencia.',
		},
		{
			year: 1997,
			description: 'Durex® lanza condones libres de látex. Un nuevo material alergénico es utilizado para el nuevo producto: el poliuretano sintético desarrollado por Durex® es más suave y elástico que el látex natural.',
		},
		{
			year: 1998,
			description: 'Durex® es la primera marca de condones en conducir y publicar una encuesta mundial de bienestar sexual.',
		},
		{
			year: 2001,
			description: 'Durex introduce Máximo Placer. Esto hace que Durex sea la primera marca de condones en vender un condón con puntos y estrías para estimular a la mujer.',
		},
		{
			year: 2003,
			description: 'Durex® lanza una emocionante gama de lubricantes.',
		},
		{
			year: 2005,
			description: 'Durex® Network lanza “the Face of Global Sex reports”, que explora los aspectos de comportamiento sexual, y son creados para la información de académicos y formuladores de políticas.',
		},
		{
			year: 2008,
			description: 'Para promover el sexo seguro entre jóvenes, Durex® alienta a los jóvenes de entre 16 y 24 años a crear un póster único sobre salud sexual – un poster de adolescentes para adolescentes.',
		},
		{
			year: 2009,
			description: '¡Durex® cumple 80 años!',
		},
		{
			year: 2010,
			description: 'Durex® apoya la iniciativa "Condomize!" del Fondo de Población de las Naciones Unidas en la Conferencia Internacional sobre el SIDA en Viena con una donación de 220,000 condones.',
		},
		{
			year: 2010,
			description: 'Durex® es adquirido por Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'Durex® introduce Clímax Mutuo, un condón diseñado para llegar al clímax en pareja. Con un recubrimiento interno que contiene 5% de benzocaína y una estructura estimulante, ayuda a tener relaciones sexuales más largas e intensas.',
		},
		{
			year: 2019,
			description: '¡Durex® cumple 90 años!',
		},
	]
}